"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizePresetIntervals = exports.filterVisibleDateFilterOptions = exports.getDateFilterOptionGranularity = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var interfaces_1 = require("../interfaces");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
function getDateFilterOptionGranularity(dateFilterOption) {
    return interfaces_1.isUiRelativeDateFilterForm(dateFilterOption) || sdk_backend_spi_1.isRelativeDateFilterPreset(dateFilterOption)
        ? dateFilterOption.granularity
        : undefined;
}
exports.getDateFilterOptionGranularity = getDateFilterOptionGranularity;
function isDateFilterOptionVisible(option) {
    return option && option.visible;
}
function pickDateFilterOptionIfVisible(option) {
    return isDateFilterOptionVisible(option) ? option : undefined;
}
function filterVisibleRelativePresets(relativePreset) {
    return Object.keys(relativePreset).reduce(function (filtered, granularity) {
        var presetsOfGranularity = relativePreset[granularity];
        var visiblePresetsOfGranularity = presetsOfGranularity.filter(isDateFilterOptionVisible);
        if (visiblePresetsOfGranularity.length) {
            filtered[granularity] = visiblePresetsOfGranularity;
        }
        return filtered;
    }, {});
}
function removeEmptyKeysFromDateFilterOptions(dateFilterOptions) {
    var absoluteForm = dateFilterOptions.absoluteForm, absolutePreset = dateFilterOptions.absolutePreset, allTime = dateFilterOptions.allTime, relativeForm = dateFilterOptions.relativeForm, relativePreset = dateFilterOptions.relativePreset;
    return tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (allTime && { allTime: allTime })), (absoluteForm && { absoluteForm: absoluteForm })), (!isEmpty_1.default(absolutePreset) && { absolutePreset: absolutePreset })), (relativeForm && { relativeForm: relativeForm })), (!isEmpty_1.default(relativePreset) && { relativePreset: relativePreset }));
}
/**
 * Returns dateFilterOptions with only items that have visible set to true.
 *
 * @param dateFilterOptions - options to filter
 * @public
 */
function filterVisibleDateFilterOptions(dateFilterOptions) {
    var _a;
    var allTime = pickDateFilterOptionIfVisible(dateFilterOptions.allTime);
    var absoluteForm = pickDateFilterOptionIfVisible(dateFilterOptions.absoluteForm);
    var relativeForm = pickDateFilterOptionIfVisible(dateFilterOptions.relativeForm);
    var absolutePreset = (_a = dateFilterOptions.absolutePreset) === null || _a === void 0 ? void 0 : _a.filter(isDateFilterOptionVisible);
    var relativePreset = dateFilterOptions.relativePreset && filterVisibleRelativePresets(dateFilterOptions.relativePreset);
    return removeEmptyKeysFromDateFilterOptions({
        allTime: allTime,
        absoluteForm: absoluteForm,
        absolutePreset: absolutePreset,
        relativeForm: relativeForm,
        relativePreset: relativePreset,
    });
}
exports.filterVisibleDateFilterOptions = filterVisibleDateFilterOptions;
function sanitizePreset(option) {
    if (option.from > option.to) {
        return tslib_1.__assign(tslib_1.__assign({}, option), { from: option.to, to: option.from });
    }
    return option;
}
function sanitizeRelativePresets(relativePreset) {
    return Object.keys(relativePreset).reduce(function (filtered, granularity) {
        var presetsOfGranularity = relativePreset[granularity];
        filtered[granularity] = presetsOfGranularity.map(sanitizePreset);
        return filtered;
    }, {});
}
/**
 * Returns dateFilterOptions with all the presets sanitized, i.e. having `from <= to`.
 * @param dateFilterOptions - options to sanitize
 */
function sanitizePresetIntervals(dateFilterOptions) {
    var _a;
    var absolutePreset = (_a = dateFilterOptions.absolutePreset) === null || _a === void 0 ? void 0 : _a.map(sanitizePreset);
    var relativePreset = dateFilterOptions.relativePreset && sanitizeRelativePresets(dateFilterOptions.relativePreset);
    return removeEmptyKeysFromDateFilterOptions(tslib_1.__assign(tslib_1.__assign({}, dateFilterOptions), { absolutePreset: absolutePreset,
        relativePreset: relativePreset }));
}
exports.sanitizePresetIntervals = sanitizePresetIntervals;
//# sourceMappingURL=OptionUtils.js.map